function makeTypeChecker(tabsRole) {
  return function (element) {
    return !!element.type && element.type.tabsRole === tabsRole;
  };
}

export var isTab = makeTypeChecker('Tab');
export var isTabList = makeTypeChecker('TabList');
export var isTabPanel = makeTypeChecker('TabPanel');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tabs/esm/helpers/elementTypes.js
// module id = null
// module chunks = 